export default __webpack_public_path__ + "static/media/girl-one.a0d973d6.jpg";